import { $Q } from '../utils/querySelector';

export const RefreshPage = () => {
  const typeProduct = $Q('[name="preorder"]');

  if (typeProduct != null) {
    if (typeProduct.value === 'continue') {
      // location.reload();
    }
  }
};
